import { render, staticRenderFns } from "./ActionCreate.vue?vue&type=template&id=1d47c537&"
import script from "./ActionCreate.vue?vue&type=script&lang=js&"
export * from "./ActionCreate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports